// -----------------------
// <auto-generated>
// Generated using the script normalizrSchemaGenerator.js
// </auto-generated>
// -----------------------
import { schema } from 'normalizr';
import {
    Category,
    Subcategory,
} from './SgmSearchApiClient';
import { BaseSgmSearchApiSchema } from './BaseSgmSearchApiSchema';

export enum ObjectsWithoutIdPropertyEnum {
    Category,
    Subcategory,
}

export type ObjectsWithoutIdProperty =
    Category
    | Subcategory;

export interface ISgmSearchEntities {
    categorys?: Record<string, unknown>;
    subcategorys?: Record<string, unknown>;
}

export class SgmSearchApiSchema extends BaseSgmSearchApiSchema {
    public static CategorySchema = new schema.Entity(
        'categorys',
        {},
        {
            idAttribute: (value: any) => SgmSearchApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.Category),
        });
    public static SubcategorySchema = new schema.Entity(
        'subcategorys',
        {},
        {
            idAttribute: (value: any) => SgmSearchApiSchema.getId(
                value,
                ObjectsWithoutIdPropertyEnum.Subcategory),
        });

    public static CategorySchemaArray = new schema.Array(SgmSearchApiSchema.CategorySchema);
    public static SubcategorySchemaArray = new schema.Array(SgmSearchApiSchema.SubcategorySchema);

    public static initialize(): void {
        SgmSearchApiSchema.CategorySchema.define({
            subcategories: SgmSearchApiSchema.SubcategorySchemaArray,
        });
    }
}

SgmSearchApiSchema.initialize();
